import React from "react";
import { Box, Stack, Text, TextLink } from "@origin-digital/ods-core";
import { IconInfo } from "@origin-digital/ods-icons";
import styled from "styled-components";

const BannerWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  background-color: #e8f4fd;
  border-radius: 8px;
  padding: ${(props) => props.theme.space.medium}px;
  gap: ${(props) => props.theme.space.xsmall}px;
`;

export interface IOfferSectionInfoBannerProps {
  title: string;
  body: string;
  linkText?: string;
  linkHref?: string;
}

export const OfferSectionInfoBanner = ({
  title,
  body,
  linkText,
  linkHref,
}: IOfferSectionInfoBannerProps) => {
  return (
    <BannerWrapper data-id="offer-section-info-banner">
      <Box paddingTop="xxsmall">
        <IconInfo size="xsmall" color="info" />
      </Box>
      <Stack space="xxsmall">
        <Text weight="medium" data-id="offer-section-info-banner-title">
          {title}
        </Text>
        <Text data-id="offer-section-info-banner-body">
          {body}{" "}
          {linkText && linkHref && (
            <TextLink data-id="offer-section-info-banner-link" href={linkHref}>
              {linkText}
            </TextLink>
          )}
        </Text>
      </Stack>
    </BannerWrapper>
  );
};
